/* Judge.me's numeric histogram: retain native filtering and name each row
 * from its displayed rating/count. Scope to this product's widget only.
 * If the app changes its markup, leave its own accessible names intact.
 */
(function () {
  'use strict';
  var widget = document.getElementById('judgeme_product_reviews');
  if (!widget || widget.hasAttribute('data-rsr-filter-labels')) return;
  widget.setAttribute('data-rsr-filter-labels', 'true');

  function numberText(element) {
    return Array.prototype.filter.call(element.childNodes, function (node) {
      return node.nodeType === Node.TEXT_NODE;
    }).map(function (node) { return node.textContent; }).join('').trim();
  }

  function suffix(element, text) {
    var label = element.querySelector('[data-rsr-filter-unit]');
    if (!label) {
      label = document.createElement('span');
      label.className = 'visually-hidden';
      label.setAttribute('data-rsr-filter-unit', '');
      label.textContent = text;
      element.appendChild(label);
    } else if (label.textContent !== text) {
      label.textContent = text;
    }
  }

  function labelFilters() {
    widget.querySelectorAll('.jm-histogram-row[role="button"]').forEach(function (row) {
      var rating = row.querySelector('.jm-histogram-row__rating');
      var frequency = row.querySelector('.jm-histogram-row__frequency');
      var star = row.querySelector('.jm-star-rating');
      if (!rating || !frequency || !star) return;
      var ratingText = numberText(rating);
      var countText = numberText(frequency);
      if (!/^[1-5]$/.test(ratingText) || !/^\d[\d,]*$/.test(countText)) return;

      suffix(rating, ratingText === '1' ? ' star' : ' stars');
      suffix(frequency, countText === '1' ? ' review' : ' reviews');
      // A decorative single star is not a separate "5 out of 1" rating.
      if (star.getAttribute('aria-hidden') !== 'true') star.setAttribute('aria-hidden', 'true');
      // Native button semantics now read rating + count in visual order.
      if (row.hasAttribute('aria-label')) row.removeAttribute('aria-label');
    });
  }

  var pending = false;
  var observer = new MutationObserver(function () {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(function () {
      pending = false;
      labelFilters();
    });
  });
  observer.observe(widget, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
  labelFilters();
}());
